import { tw } from "@careinfo/tailwind";
import { HTMLAttributes } from "react";
import { classNames } from "../../utils/classNames";
import Spinner from "../Spinner";

interface Props extends HTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  disabled?: boolean;
  label?: string;
  type?: "submit" | "button";
}

const Button = (props: Props) => {
  const {
    type = "submit",
    label,
    isLoading = false,
    disabled = false,
    ...other
  } = props;
  return (
    <>
      <button
        type={type}
        disabled={isLoading || disabled}
        className={classNames(
          isLoading || disabled ? tw`bg-gray-500` : tw`bg-primary`,
          tw`w-full h-full text-white py-2 rounded  focus:outline-none`
        )}
        {...other}
      >
        {isLoading ? <Spinner /> : label}
      </button>
    </>
  );
};

export default Button;
